import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { Helmet } from 'react-helmet-async';
import { discoveryApi } from '../../api/discovery';
import PageLayout from '../../components/layout/PageLayout';
import SEO from '../../components/common/SEO';
import useTrackPageView from '../../hooks/useTrackPageView';
import { PAGE_TYPE } from '../../constants/gaEnums';
import { SITE_URL } from '../../utils/env';
import PersonalizedHome from './PersonalizedHome';
import { useBrowseSession } from '../../features/browse/useBrowseList';
import { useWebLocale } from '../../contexts/WebLocaleContext';

export default function Home() {
  useTrackPageView({ pageType: PAGE_TYPE.HOME });
  const { entry } = useBrowseSession('home');
  const { locale } = useWebLocale();
  const homeQuery = useQuery({
    queryKey: ['web-parity', 'explore', 'home', entry.version, locale],
    queryFn: ({ signal }) => discoveryApi.home(signal),
    staleTime: 300000,
    retry: false,
    refetchOnWindowFocus: false,
  });
  return (
    <PageLayout paddingTop={{ xs: '12px', md: '8px' }}>
      <SEO title="Postpop. Your Own Archive" rawTitle />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Postpop',
            alternateName: '포스트팝',
            url: SITE_URL,
            logo: `${SITE_URL}/favicon.png`,
            description:
              '포스트팝은 음악 리뷰 커뮤니티입니다. 앨범을 발견하고 리뷰와 플레이리스트를 나누며 나만의 음악 취향을 아카이빙 해보세요.',
            email: 'contact@postpop.kr',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '성지길 36-5 1층 104호',
              addressLocality: '마포구',
              addressRegion: '서울',
              addressCountry: 'KR',
            },
            sameAs: ['https://www.instagram.com/postpop.kr/'],
          })}
        </script>
      </Helmet>
      <PersonalizedHome homeQuery={homeQuery} />
    </PageLayout>
  );
}
